import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import RadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup'
import * as React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

interface FormsProps extends Omit<RadioGroupProps, 'children'> {
    label?: string
    name: string
    options: { value: string; label: string }[]
    helperText?: string
}

export const FormRadioGroup: React.FC<FormsProps> = ({
    label,
    options,
    helperText,
    name,
    ...props
}) => {
    const { control } = useFormContext()
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <FormControl>
                    {label ? (
                        <FormLabel
                            sx={{
                                '&.Mui-focused': { color: 'inherit' },
                            }}
                        >
                            {label}
                        </FormLabel>
                    ) : null}
                    <RadioGroup {...props} {...field}>
                        {options.map(option => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio />}
                                label={option.label}
                            />
                        ))}
                    </RadioGroup>
                    {helperText && !error ? (
                        <FormHelperText>{helperText}</FormHelperText>
                    ) : null}
                    {error ? (
                        <FormHelperText error>{error.message}</FormHelperText>
                    ) : null}
                </FormControl>
            )}
        />
    )
}
